import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// 思源黑体 Black（SIL OFL 免费商用）——页面标题（.page-title）等重字重文字专用，unicode-range 分片按需加载（仅下载用到的字形）
import '@fontsource/noto-sans-sc/900.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
